import { TrackAssessmentStandard } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const trackAssessmentApi = createApi({
  reducerPath: 'trackAssessmentApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getTrackAssessmentStandards: build.query<TrackAssessmentStandard[], undefined>({
      query: () => 'track-assessment-standards',
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetTrackAssessmentStandardsQuery,

  usePrefetch: usePrefetchTrackAssessment,

  util: { resetApiState },
} = trackAssessmentApi;
